<template>
  <div class="about">
    <div class="paragraph">
      <div class="stat-container">
        <div class="stat" v-for="stat in statList" :key="stat.name">
          <div class="value">{{ `${stat.displayValue.toLocaleString()} ${stat.value >= 1000000 ? $t('About.million') : '' }` }}</div>
          <div class="name">{{ $t(`About.${stat.name}`) }}</div>
        </div>
      </div>
      <div class="award-container" @click="clickAward">
        <img style="width: 100%;" :src="util.getImagePath(`award_about_${$i18n.locale}@2x.png`)" :srcset="util.getImageSet(`award_about_${$i18n.locale}`)">
      </div>
    </div>
    <div class="paragraph">
      <div class="head">{{ $t('About.whatIsPromptPai.topic') }}</div>
      <div class="body">
        <p>
          <span class="bold">{{ $t('About.whatIsPromptPai.promptPai') }}</span>{{ $t('About.whatIsPromptPai.description1') }}
          <ol>
            <li>{{ $t('About.whatIsPromptPai.description2') }}<a href="/p/10000001" class="link bold primary-color" @click="clickLink($event, '/p/10000001', true)">{{ $t('About.whatIsPromptPai.description3') }}</a></li>
            <li>{{ $t('About.whatIsPromptPai.description4') }}<a href="/t/021081790" class="link bold primary-color" @click="clickLink($event, '/t/021081790', true)">{{ $t('About.whatIsPromptPai.description5') }}</a></li>
          </ol>
          {{ $t('About.whatIsPromptPai.description6') }}
          <br>
          <div class="qr-example-container">
            <img :src="util.getImagePath(`promptpai_10000001_${$i18n.locale}.png`)">
          </div>
          <div style="text-align: center; width: 100%; text-indent: 0px;">{{ $t('About.whatIsPromptPai.description7') }}</div>
        </p>
      </div>
    </div>
    <div class="paragraph">
      <div class="head">{{ $t('About.whyPromptPai.topic') }}</div>
      <div class="body">
        <p>
          {{ $t('About.whyPromptPai.description1') }}<span class="bold">{{ $t('About.whyPromptPai.description2') }}</span>{{ $t('About.whyPromptPai.description3') }}<a href="/p/10000001" class="link bold primary-color" @click="clickLink($event, '/p/10000001', true)">{{ $t('About.whyPromptPai.description4') }}</a>{{ $t('About.whyPromptPai.description5') }}<a href="/t/021081790" class="link bold primary-color" @click="clickLink($event, '/t/021081790', true)">{{ $t('About.whyPromptPai.description6') }}</a>{{ $t('About.whyPromptPai.description7') }}
        </p>
      </div>
    </div>
    <div class="paragraph">
      <div class="head">{{ $t('About.isItFree.topic') }}</div>
      <div class="body">
        <p>
          {{ $t('About.isItFree.description1') }}<span class="bold">{{ $t('About.isItFree.description2') }}</span>{{ $t('About.isItFree.description3') }}
          <ol>
            <li>{{ $t('About.howToUse1') }}</li>
            <li>{{ $t('About.howToUse2') }}</li>
            <li>{{ $t('About.howToUse3') }}</li>
          </ol>
        </p>
        <img style="width: 256px; margin: auto calc((100% - 256px) / 2);" :src="util.getImagePath(`how_to_use_${$i18n.locale}@3x.png`)" :srcset="util.getImageSet(`how_to_use_${$i18n.locale}`)">
      </div>
    </div>
    <div class="paragraph">
      <div class="head">{{ $t('About.howDoIKnow.topic') }}</div>
      <div class="body">
        <p>
          {{ $t('About.howDoIKnow.description1') }}<a href="/" class="link bold primary-color" @click="clickLink($event, '/', true)">{{ $t('About.howDoIKnow.description2') }}</a>{{ $t('About.howDoIKnow.description3') }}
        </p>
      </div>
    </div>
    <div class="paragraph">
      <div class="head">{{ $t('About.canICreate.topic') }}</div>
      <div class="body">
        <p>
          {{ $t('About.canICreate.description1') }}<a href="/" class="link bold primary-color" @click="clickLink($event, '/', true)">{{ $t('About.canICreate.description2') }}</a>{{ $t('About.canICreate.description3') }}
        </p>
        <div class="create-step-container">
          <div>
            <img :src="util.getImagePath(`create_step_1_${$i18n.locale}@3x.png`)" :srcset="util.getImageSet(`create_step_1_${$i18n.locale}`)">
            <p>1. {{ $t('About.createStep1') }}</p>
          </div>
          <div>
            <img :src="util.getImagePath(`create_step_2_${$i18n.locale}@3x.png`)" :srcset="util.getImageSet(`create_step_2_${$i18n.locale}`)">
            <p>2. {{ $t('About.createStep2') }}</p>
          </div>
          <div> 
            <img :src="util.getImagePath(`create_step_3_${$i18n.locale}@3x.png`)" :srcset="util.getImageSet(`create_step_3_${$i18n.locale}`)">
            <p>3. {{ $t('About.createStep3') }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="paragraph">
      <div class="head">{{ $t('About.shouldIUse.topic') }}</div>
      <div class="body">
        <p>
          {{ $t('About.shouldIUse.description1') }}<span class="bold">{{ $t('About.shouldIUse.description2') }}</span>{{ $t('About.shouldIUse.description3') }}<span class="bold">{{ $t('About.shouldIUse.description4') }}</span>{{ $t('About.shouldIUse.description5') }}
        </p>
      </div>
    </div>
    <div class="paragraph">
      <div class="head">{{ $t('About.whereCanIUse.topic') }}</div>
      <div class="body">
        {{ $t('About.whereCanIUse.description1') }}
        <li><a href="https://map.longdo.com" class="link bold primary-color" @click="clickLink($event, 'https://map.longdo.com', false)">{{ $t('About.whereCanIUse.description2') }}</a>{{ $t('About.whereCanIUse.description3') }}</li>
        <div class="longdo-map-image-container">
          <img :src="util.getImagePath(`longdo_map_1_${$i18n.locale}@2x.png`)" :srcset="util.getImageSet(`longdo_map_1_${$i18n.locale}`)">
          <img :src="util.getImagePath(`longdo_map_2_${$i18n.locale}@2x.png`)" :srcset="util.getImageSet(`longdo_map_2_${$i18n.locale}`)">
        </div>
        {{ $t('About.whereCanIUse.description4') }}<span class="bold">{{ $t('About.whereCanIUse.description5') }}</span>
      </div>
    </div>
    <div class="paragraph">
      <div class="head">{{ $t('About.exampleUses.topic') }}</div>
      <div class="body">
        <li>{{ $t('About.exampleUses.description1') }}</li>
        <li>{{ $t('About.exampleUses.description2') }}</li>
        <div class="qr-taxi-container">
          <img :src="util.getImagePath(`usage_flow.png`)" :srcset="util.getImageSet('usage_flow')">
        </div>
      </div>
    </div>
    <div class="paragraph">
      <div class="head">{{ $t('About.howDoIEnableSupport.topic') }}</div>
      <div class="body">
        {{ $t('About.howDoIEnableSupport.description1') }}<a href="/ws" class="link bold primary-color" @click="clickLink($event, '/ws', true)">{{ $t('About.howDoIEnableSupport.description2') }}</a>{{ $t('About.howDoIEnableSupport.description3') }}
      </div>
    </div>
    <div class="paragraph">
      <div class="head">{{ $t('About.whyShouldWeUse.topic') }}</div>
      <div class="body">
        {{ $t('About.whyShouldWeUse.description1') }}
      </div>
    </div>
    <div class="paragraph download" v-if="showDownload">
      <div class="head">{{ $t('About.download.topic') }}</div>
      <DownloadApp/>
    </div>
    <div class="paragraph line">
      <div class="head">{{ $t('About.line.topic') }}</div>
      <a href="https://lin.ee/tdLwtpH" @click="clickLink($event, 'https://lin.ee/tdLwtpH', false)"><img :src="`https://scdn.line-apps.com/n/line_add_friends/btn/${$i18n.locale}.png`" alt="@promptpai" height="36" border="0"></a>
      <div class="account-id">@promptpai</div>
    </div>
    <div class="paragraph version" v-if="util.getUserAgentMeta() === 'iOS application'">
      {{ $t('About.whatIsPromptPai.promptPai') }} iOS Application v.{{ version }}
    </div>
    <div class="paragraph version" v-if="util.getUserAgentMeta() !== 'iOS application' && util.getUserAgentMeta() !== 'Android application'">
      {{ $t('About.whatIsPromptPai.promptPai') }} Web Application v.{{ webVersion }}
    </div>
  </div>
</template>

<script>
import DownloadApp from '@/components/DownloadApp.vue'
import { clearInterval } from 'timers'
export default {
  name: 'About',
  components: {
    DownloadApp
  },
  metaInfo () {
    return {
      title: 'พร้อมไป ไปถึงทุกที่ไม่มีพลาด',
      meta: [
        {
          name: 'description',
          content: 'การระบุตำแหน่งสถานที่โดยใช้ตัวเลข (Map code) แทนข้อมูลที่อยู่ ชื่อสถานที่ พิกัด Latitude Longitude หรือข้อมูลอื่นที่เกี่ยวข้องกับสถานที่นั้น'
        },
        {
          name: 'keywords',
          content: 'พร้อมไป, PromptPai'
        },
        {
          property: 'fb:app_id',
          content: '148173948530677'
        },
        {
          property: 'og:site_name',
          content: 'PromptPai'
        },
        {
          property: 'og:image',
          content: 'https://promptpai.com/static/image/promptpai_app_icon_xxxhdpi.png'
        },
        {
          property: 'og:image:type',
          content: 'image/png'
        },
        {
          property: 'og:url',
          content: 'https://promptpai.com'
        },
        {
          property: 'og:description',
          content: 'การระบุตำแหน่งสถานที่โดยใช้ตัวเลข (Map code) แทนข้อมูลที่อยู่ ชื่อสถานที่ พิกัด Latitude Longitude หรือข้อมูลอื่นที่เกี่ยวข้องกับสถานที่นั้น'
        },
        {
          property: 'og:title',
          content: 'พร้อมไป ไปถึงทุกที่ไม่มีพลาด'
        }
      ]
    }
  },
  data () {
    return {
      statList: [
        {
          name: 'promptPaiStat',
          displayValue: 0,
          value: 0
        },
        {
          name: 'telStat',
          displayValue: 0,
          value: 0
        },
        {
          name: 'searchStat',
          displayValue: 0,
          value: 0
        },
        {
          name: 'userStat',
          displayValue: 0,
          value: 0
        }
      ],
      intervalValue: undefined,
      version: '',
      build: '',
      webVersion: process.env.VERSION
    }
  },
  computed: {
    showDownload () {
      return this.util.getUserAgentMeta() !== 'Android application' && this.util.getUserAgentMeta() !== 'iOS application'
    }
  },
  mounted () {
    var self = this
    if (self.util.getUserAgentMeta() === 'iOS application') {
      window.receiveVersion = (version, build) => {
        self.version = version
        self.build = build
      }
      window.location.href = `https://native.getversion`
    }
    document.querySelector('#app').scrollTop = '0px'
    self.getStat()
  },
  methods: {
    getStat () {
      var self = this
      self.pp.getPromptpaiStat(
        (result) => {
          if (result.status.code === 200) {
            if (result.data) {
              self.statList[0].value = result.data.number_of_promptpai
              self.statList[1].value = result.data.number_of_phoneno
              self.statList[2].value = result.data.number_of_usage
              self.statList[3].value = result.data.number_of_user
              self.intervalValue = setInterval(() => {
                self.statList.forEach(s => {
                  let n = s.value >= 1000000 ? parseInt(s.value / 1000000) : s.value
                  let a = `${n - s.displayValue}`.length - 1
                  if (s.displayValue < n) {
                    s.displayValue += Math.pow(10, a)
                  }
                })
              }, 50)
            }
          } else if (result.status.code === 403) {
          } else {
          }
          self.isMakingFav = false
        }
      )
    },
    clickAward () {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      var url = `https://mm.co.th/node/132`
      window.gtag('config', 'UA-143787399-1', {
        'page_path': url
      })
      if (userAgent === 'iOS application') {
        window.location.href = `https://native.openUrl?url=${encodeURIComponent(url)}`
      } else if (userAgent === 'Android application') {
        Android.openUrl(url)
      } else {
        window.open(url, '_blank')
      }
    },
    clickLink (e, url, addOrigin) {
      e.preventDefault()
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      self.isOpenMenuPanel = false
      window.gtag('config', 'UA-143787399-1', {
        'page_path': url
      })
      if (addOrigin) {
        url = `${window.location.origin}${url}`
      }
      if (userAgent === 'iOS application') {
        window.location.href = `https://native.openUrl?url=${encodeURIComponent(url)}`
      } else if (userAgent === 'Android application') {
        Android.openUrl(url)
      } else {
        window.open(url, '_blank')
      }
      return false
    }
  },
  beforeDestroy () {
    var self = this
    clearInterval(self.intervalValue)
  }
}
</script>

<style scoped>
  .about {
    padding: 16px;
    display: flex;
    flex-direction: column;
  }

  .stat-container {
    width: 100%;
    min-width: calc(320px - 32px);
    max-width: 640px;
    margin: 0px auto 0px auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .stat {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: calc(50% - 8px);
    margin: 16px 0px 0px 0px;
    background-color: rgba(255, 255, 255, 0.95);
    border-radius: 10px;
    padding: 8px;
    box-sizing: border-box;
  }

  .stat .value {
    font-family: Prompt;
    font-size: 32px;
    font-weight: bold;
    text-align: center;
  }

  .stat .name {
    font-family: Prompt;
    font-size: 20px;
    color: rgb(34, 84, 156);
  }

  .award-container {
    width: 100%;
    min-width: calc(320px - 32px);
    max-width: 640px;
    margin: 16px auto 0px auto;
    text-align: center;
    background-color: transparent;
    padding: 0px;
    box-sizing: border-box;
    border-radius: 10px;
    cursor: pointer;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .paragraph {
    width: 100%;
    min-width: calc(320px - 32px);
    max-width: 640px;
    margin: 40px auto 0px auto;
  }

  .paragraph > .head {
    font-family: Prompt;
    font-size: 22px;
    color: rgb(255, 255, 255);
  }

  .paragraph > .body {
    background-color: rgba(255, 255, 255, 0.95);
    border-radius: 10px;
    padding: 16px;
    line-height: 1.75;
    text-align: left;
  }

  .paragraph > .body * {
    line-height: 1.75;
  }

  p {
    margin: 0px;
  }

  li {
    text-indent: 8px;
  }

  .primary-color {
    color: rgb(34, 84, 156);
  }

  .bold {
    font-weight: bold;
  }

  .link {
    cursor: pointer;
    text-decoration: none;
  }

  .create-step-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    padding-top: 16px;
  }

  .create-step-container > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: calc(100% / 3);
  }

  .create-step-container > div > p {
    text-align: center;
    padding: 16px 8px 0px 8px;
  }

  .create-step-container > div > img {
    max-width: 200px;
    width: calc(100% - 32px);
    margin: auto;
  }

  .qr-example-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 8px auto 0px auto;
  }

  .qr-example-container > img {
    max-width: 200px;
  }

  .longdo-map-image-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    margin: 0px 0px 16px 0px;
  }

  .longdo-map-image-container > img {
    width: calc((100% - 16px) / 2);
    display: block;
    margin-top: 16px;
  }

  .qr-taxi-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0px;
  }

  .qr-taxi-container > img {
    max-width: 100%;
  }

  .download {
    text-align: center;
    margin-bottom: 20px;
  }

  .line {
    text-align: center;
    margin-bottom: 20px;
  }

  .line .head {
    margin-bottom: 8px;
  }

  .line .account-id {
    color:rgb(255, 255, 255);
    line-height: 1.75;
  }

  .version {
    text-align: center;
    color: rgb(255, 255, 255);
    text-shadow: 0px 0px 5px rgb(0, 0, 0);
    font-size: 14px;
  }

  @media only screen and (max-width: 480px) {
    .stat {
      width: 100%;
    }

    .create-step-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }

    .create-step-container > div {
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: flex-start;
      width: 100%;
      padding: 0px;
    }

    .create-step-container > div > p {
      text-align: left;
      padding: 32px 0px 8px 0px;
    }

    .longdo-map-image-container > img {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/About.vue